// extracted by mini-css-extract-plugin
export default {"tc":"tc__d912g","mt":"mt__31e8L"};